import { useEffect, useState } from "react"
import { SocialNetworkService } from "../../services/socialNetworkService";
import type { SocialLink } from "../../interfaces/socialLink";
import "./social-networks.scss";
import { FaFacebook, FaYoutube, FaTiktok,FaInstagram  } from "react-icons/fa";
import type { IconType } from "react-icons";

    const rs:any ={
        instagram:FaInstagram,
        facebook:FaFacebook,
        tiktok:FaTiktok,
        youtube:FaYoutube,
    }
     
    export function SocialNetworks(){

        function renderIcon(keyRs:any){
            const SocialNetworkIcon: IconType = rs[keyRs];
            return SocialNetworkIcon ? <SocialNetworkIcon /> : null;
        }




        const [socialLinks,setSocialLinks] = useState<SocialLink[]|[]>([]);
        useEffect (()=>{
            SocialNetworkService().getAll().then(
                (result)=>{
                    setSocialLinks(result.data);
                }
            )
        },[])

        return(
            <>
                {socialLinks.length?
                    <ul className="social-networks-container">
                        {socialLinks.map((link:SocialLink)=>{
                            return <li key={link.id}><a href={link.url} target="_blank" title={link.name}>{renderIcon(link.icon)}</a></li>
                        })}
                    </ul>
                :''}
            </>
        )
    }